import React from 'react';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { Modal, Button} from 'antd';

import AccountList from './Account/account';

import './adminAccount.scss';

class AdminAccount extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            // providers: defaultProviders,
        }
    }
    render() {
        const { providers } = this.state
        const { match } = this.props
        const { user, history } = this.props
        
        return (
            <div className="admin-account-list-wrapper">
                <div className="header">
                    <div className="left-wrapper">
                        <h2>Account</h2>
                    </div>
                    <div className="right-wrapper">
                        <Button 
                            className="add-account-btn"
                            type="primary" 
                            onClick={() => history.push('/addNewAccount')}>
                            Add New Account
                        </Button>
                    </div>
                </div>
                <div className="admin-account-list">
                    <AccountList/>
                </div>
          </div>
            
        )
    }
}

export default withRouter((AdminAccount))
